



































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import QlogConnection from "@/data/Connection";
import * as qlog from '@/data/QlogSchema';

import MultiplexingGraphConfig from "./data/MultiplexingGraphConfig";
import MultiplexingGraphD3SimulationRenderer from "./renderer/MultiplexingGraphD3SimulationRenderer";
import MultiplexingGraphD3CollapsedRenderer from "./renderer/MultiplexingGraphD3CollapsedRenderer";
import MultiplexingGraphD3WaterfallRenderer from "./renderer/MultiplexingGraphD3WaterfallRenderer";
import ColorHelper from '../shared/helpers/ColorHelper';

@Component
export default class MultiplexingGraphCollapsedRenderer extends Vue {
    @Prop()
    public connection!: QlogConnection;

    @Prop()
    public showwaterfall!: boolean;

    @Prop()
    public showbyteranges!:boolean;

    protected waterfallRenderer!: MultiplexingGraphD3WaterfallRenderer;
    // protected fifoRenderer!: MultiplexingGraphD3SimulationRenderer;
    protected dataRenderer!: MultiplexingGraphD3CollapsedRenderer;

    protected streamDetail:any = null;

    protected skipRender:boolean = false;

    protected get id_waterfall() {
        // TODO: proper GUID!
        return this.id_fifo.replace("-fifo-", "-waterfall-");
    }

    protected get id_fifo() {
        // TODO: proper GUID!
        return "multiplexing-fifo-" + Math.round((Math.random() * 100000));
    }

    protected get id_data() {
        // TODO: proper GUID!
        return this.id_fifo.replace("-fifo-", "-data-");
    }

    protected get id_byterange() {
        return this.id_fifo.replace("-fifo-", "-byterange-");
    }

    protected get showstreamdetail() {
        return this.streamDetail !== null;
    }

    public created() {

        // TODO: hook up the .onStreamClicked on the CollapsedRenderer as well
        // didn't do that at first because the needed information wasn't readily available there yet, only in the waterfall
        this.waterfallRenderer = new MultiplexingGraphD3WaterfallRenderer( this.id_waterfall, (streamDetails:any) => { this.onStreamClicked(streamDetails); } );
        // this.fifoRenderer = new MultiplexingGraphD3SimulationRenderer( this.id_fifo );

        this.dataRenderer  = new MultiplexingGraphD3CollapsedRenderer( this.id_data, this.id_byterange );
    }

    public mounted() {
        // mainly for when we switch away, and then back to the streamgraph
        this.updateRenderers();
    }

    public updated() {
        this.updateRenderers();
    }

    protected onStreamClicked(streamDetails:any) {
        // this updates one part of the viz, but would also trigger an update to the rest
        // this messes with our ByteRangesRenderer, since that's not stateful from VUE perspective yet
        // so, as a dirty hack, skip the next render here... also works for now 
        this.skipRender = true;
        this.streamDetail = streamDetails;

        this.streamDetail.style = { display: "inline-block", paddingRight: "10px", width: "50px", height: "100%", backgroundColor : ColorHelper.StreamIDToColor( "" + this.streamDetail.stream_id, "HTTP3" )[0] };
    }

    protected updateRenderers() {

        if ( this.skipRender ) {
            this.skipRender = false;

            return;
        }

        // we need all three renderers to have the exact same width
        // originally, we just had them lookup their container's clientWidth in the renderers themselves
        // however, when adding a vertical scrollbar to the waterfall, this started to break in weird ways
        // so now, we calculate the appropriate width from the page's width here and set hem manually, so in the renderers, container.clientWidth is always correct
        // There is 15px padding on each side for each column, plus for the top level container, so 90px in total
        // up-front col is 1/12th of the width. Then we want 99% (not to cause a horizontal scrollbar as well) of the remaining 11/12th = 0.9075
        const fixedWidth = Math.ceil(((document.getElementById("multiplexingToplevelContainer")!.clientWidth - 90) * 0.9075)) + "px";
        document.getElementById( "" + this.id_data )!.style.width       = fixedWidth;
        if ( this.showwaterfall )
            document.getElementById( "" + this.id_waterfall )!.style.width  = fixedWidth;
        if ( this.showbyteranges )
            document.getElementById( "" + this.id_byterange )!.style.width  = fixedWidth;

        // Using v-if to toggle some renderers. This is not frame-perfect.
        // The renderers use things like .clientWidth to size themselves, for which the toggle really has to be completed
        // So we use a timeout to make sure this has happened before (re-)rendering
        setTimeout( () => { 
            // IMPORTANT: mounted() and updated() are only called if connection changes, if we actually use the connection in the render somewhere
            // if we don't, vue's coupling doesn't happen, even though it's a prop!!
            // if you remove connection from the rendering, have to add a Watch() statement instead
            if ( this.connection !== undefined ) {
                if ( this.showwaterfall ) {
                    this.waterfallRenderer.render ( this.connection );
                    // needed to hook up click handlers
                    // FIXME: this is quite dirty... should probably be done with a general config object
                    this.dataRenderer.waterfallRenderer = this.waterfallRenderer;
                }
                else {
                    this.dataRenderer.waterfallRenderer = undefined;
                }
                // this.fifoRenderer.render( this.connection );
                this.dataRenderer.render( this.connection );
            }
        }, 100 );
    }
}

